import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "SRAGCircle OPC | IT Systems Integration & Automation Solutions Philippines",
  description = "SRAGCircle OPC is a SEC-registered Philippine corporation specializing in IT systems integration, SCADA automation, security surveillance, electrical power solutions, and facilities management services in Metro Manila.",
  keywords = "IT systems integrator Philippines, SCADA automation, security surveillance, facilities management",
  canonical = "",
  type = "website"
}) => {
  const siteUrl = "https://sragcircle.com";
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      
      {/* Twitter */}
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
